"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _style = require("../../style");

var genEllipsisStyle = function genEllipsisStyle(token) {
  var _Object$assign;

  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-cell-ellipsis"), Object.assign(Object.assign({}, _style.textEllipsis), (_Object$assign = {
    wordBreak: 'keep-all'
  }, _defineProperty(_Object$assign, "\n          &".concat(componentCls, "-cell-fix-left-last,\n          &").concat(componentCls, "-cell-fix-right-first\n        "), _defineProperty({
    overflow: 'visible'
  }, "".concat(componentCls, "-cell-content"), {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  })), _defineProperty(_Object$assign, "".concat(componentCls, "-column-title"), {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'keep-all'
  }), _Object$assign))));
};

var _default = genEllipsisStyle;
exports.default = _default;